import React, { useEffect, useState, useRef } from 'react';
import { Form, Row, Modal, Col } from 'react-bootstrap';
import withLayout from '../../components/Layout/withLayout';
import { EQ_TYP } from '../../components/constant';
import { StyledButton } from '../../StyledComponets';
import {
  updateEquipment,
  getEquipmentUpdateResponse,
} from '../../app/equipment/updateEquipmentSlice';
import { useDispatch, useSelector } from 'react-redux';

function EquipmentMgmt() {
  const initialFormState = {
    EquipmentType: EQ_TYP.pv_inverter,
    formFile: null,
  };
  const [formState, setFormState] = useState(initialFormState);
  const [successUpload, showSuccessUpload] = useState(false);
  const fileRef = useRef(null);

  const dispatch = useDispatch();
  const uploadEquipmentStatus = useSelector(getEquipmentUpdateResponse);

  const onEquipmentChange = (e) => {
    setFormState({ ...formState, EquipmentType: e.target.value });
  };
  const onFileChange = (e) => {
    setFormState({ ...formState, formFile: e.target.files[0] });
  };
  const uploadEquipment = () => {
    dispatch(updateEquipment(formState));
  };

  const resetForm = () => {
    setFormState(initialFormState);
    showSuccessUpload(false);
    fileRef.current.value = null;
  };

  useEffect(() => {
    if (uploadEquipmentStatus?.includes('uploaded') && formState.formFile) {
      showSuccessUpload(true);
    }
  }, [uploadEquipmentStatus]);

  return (
    <>
      <br />
      <>
        <Row>
          <Col>
            <Form.Group
              controlId="formFileSm"
              className="mb-3"
              style={{ marginTop: '-5px' }}
            >
              <Form.Text
                size="sm"
                style={{ margin: '13px' }}
                htmlFor="equipOption"
              >
                Equipment Type
              </Form.Text>
              <Form.Select
                size="sm"
                aria-label="equipOption"
                onChange={onEquipmentChange}
              >
                <option value={EQ_TYP.pv_inverter}>Solar Inverter</option>
                <option value={EQ_TYP.bt_inverter}>Battery Inverter</option>
                <option value={EQ_TYP.battery}>Battery</option>
                <option value={EQ_TYP.solar}>Solar</option>
                <option value={EQ_TYP.ess}>Integarted Energy Storage</option>
                <option value={EQ_TYP.pcs}>PCS Data</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="formFileSm" className="mb-3">
              <Form.Text
                style={{ margin: '2px' }}
                size="sm"
                htmlFor="equipOption"
              >
                Template File
              </Form.Text>
              <Form.Control
                ref={fileRef}
                type="file"
                name="formFile"
                accept=".xlsx,.xls"
                onChange={onFileChange}
              />
            </Form.Group>
          </Col>
        </Row>
        <StyledButton
          btnType="primary"
          variant="dark"
          size="sm"
          onClick={uploadEquipment}
          disabled={!formState.formFile}
        >
          Upload
        </StyledButton>
      </>
      <Modal
        centered
        size="lg"
        onShow={() => {}}
        onExited={() => {}}
        show={successUpload}
        onHide={() => {
          resetForm();
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Equipment template upload success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className="text-center">
            Please check the updated equipments after refresh
          </h5>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default withLayout(EquipmentMgmt);
